// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_localization-block.scss
// module id = 43
// module chunks = 0